module.exports = __webpack_public_path__ + "img/logo-ticketshop-carousel.04851213.png";